import Marquee from "react-fast-marquee";

const sports = [
  "Golf", "Football", "Cricket", "Tennis", "Basketball", "Rugby", "Baseball",
  "Archery", "Ice Hockey", "Pickleball", "Padel", "Ten Pin Bowling",
  "American Football", "Dodgeball", "Lacrosse", "Volleyball", "Badminton", "Squash",
];

export default function SportsMarquee() {
  return (
    <div data-testid="sports-marquee" className="py-14 border-b border-white/[0.06] overflow-hidden">
      <Marquee speed={28} autoFill gradient gradientColor="#05050A" gradientWidth={120}>
        {sports.map((s) => (
          <span key={s} className="flex items-center">
            <span className="font-heading font-light uppercase tracking-[0.35em] text-xl md:text-2xl text-white/25 hover:text-[#00D4FF] transition-colors duration-300">
              {s}
            </span>
            <span className="mx-10 md:mx-16 h-1.5 w-1.5 rounded-full bg-[#007AFF]/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
